import { createComponent } from '@lit-labs/react';
import React from 'react';

import { OnChatBotClient as OnChatBotClientWC } from '../../web-components/bot-client/bot-client';

const OnChatBotClient = createComponent(
  React,
  'on-chat-bot-client',
  OnChatBotClientWC
);

export default OnChatBotClient;
